<div class="modal-header">
  <h4 class="modal-title text-center text-primary">{{ 'stripe.title' | translate }}</h4>
</div>
<div class="modal-body d-flex flex-column align-items-center">
  <div *ngIf="!isLoading" class="d-flex flex-column align-items-center">
    <img src="/assets/images/popup-icons/success.svg" loading="lazy" alt="complete" class="icon"
      *ngIf="status === 'success'" />
    <img src="/assets/images/popup-icons/warning.svg" loading="lazy" alt="warning" class="icon"
      *ngIf="status === 'failed'" />

    <div class="fw-bold font-18 text-center text-success mt-3 text-uppercase" *ngIf="status === 'success'">{{
      'stripe.payment_success' |
      translate }}</div>
    <div class="fw-bold font-18 text-center text-danger mt-3 text-uppercase" *ngIf="status === 'failed'">{{
      'stripe.payment_failed' |
      translate }}</div>
  </div>
  <img src="/assets/images/png/token.png" alt="loading" class="loading icon" loading="lazy" *ngIf="isLoading" />
  <div class="fw-medium font-16 text-center text-white mt-3" *ngIf="isLoading">{{ 'stripe.payment_verifying' |
    translate }}
  </div>

  <div class="footer">
    <button type="button" class="btn btn-primary w-100 mt-4 icon-btn d-block" (click)="modalRef.hide()">{{
      'misc.close' | translate }}</button>
  </div>
</div>